import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import { TagModel } from 'models';

import { Accordion } from 'core/ui';

import { TagsField } from 'features/tags/fragments';

// Heart monitor icon is used in other TagsAccordion
import HeartMonitorIcon from '../assets/heart-monitor.svg?react';

interface TagsFieldAccordionProps {
  eventKey: string;
  tags: TagModel[];
  selectedTags?: TagModel[];
  onSelectedTagsChange?: (tags: TagModel[]) => void;
  initialExpandedIds?: number[];
}

export const TagsFieldAccordion: React.FC<TagsFieldAccordionProps> = ({
  eventKey,
  tags = [],
  selectedTags: externalSelectedTags,
  onSelectedTagsChange: externalOnSelectedTagsChange,
  initialExpandedIds,
}) => {
  const [internalSelectedTags, setInternalSelectedTags] = useState<TagModel[]>([]);

  const currentSelectedTags = externalSelectedTags !== undefined ? externalSelectedTags : internalSelectedTags;

  useEffect(() => {
    // If you were previously initializing from selectedTagIds (number[]),
    // you would need logic here to find the corresponding TagModel objects from the `tags` prop.
    // For this refactor, we assume the parent now provides `selectedTags` (TagModel[]) directly if controlled.
    // Example:
    // if (externalSelectedTags === undefined && externalSelectedTagIds && tags.length > 0) {
    //   const initialSelected = tags.filter(tag => externalSelectedTagIds.includes(tag.id));
    //   setInternalSelectedTags(initialSelected);
    // }
  }, [tags]);

  const handleTagsChange = (newSelectedItems: TagModel[]) => {
    if (externalOnSelectedTagsChange) {
      externalOnSelectedTagsChange(newSelectedItems);
    } else {
      setInternalSelectedTags(newSelectedItems);
    }
  };

  return (
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header Icon={HeartMonitorIcon} title="Tags Field" />
      <StyledAccordionBody>
        <TagsField tags={tags} value={currentSelectedTags} onChange={handleTagsChange} initialExpandedIds={initialExpandedIds} />
      </StyledAccordionBody>
    </Accordion.Item>
  );
};

const StyledAccordionBody = styled(Accordion.Body)`
  padding: ${({ theme }) => theme.space.spacing30};
`;

export default TagsFieldAccordion;
